import { DatePipe } from '@angular/common';
import { PagedResponseModel } from '../PagedResponseModel';

export class PagedPublicationHistoryList extends PagedResponseModel {
    public list: PublicationHistoryItem[];
    public currentPage: number;
    public PageSize: number;
    public totalRecords: number;
    public initialDate: Date;
    public endDate: Date;
}

export class PublicationHistoryItem {
    publicationHistoryId: string;
    eeaNumber: string;
    projectName: string;
    location: string;
    commentsDue: string;
    forCopies: string;
    mepaAnalyst: string;
    type: string;
    time: string;
    action: string;
    agency: string;
    isCommentDisabled: boolean;
    withdrawn: boolean;
    attachmentCount: number;
    noticeType: string;
    municipalId: string;
    submittalId: string;

    static OpenForComment(redirectURL: string, publicationHistoryItem: PublicationHistoryItem, datePipe: DatePipe) {
        redirectURL = redirectURL + "&SubjectUniqueId=" + publicationHistoryItem.eeaNumber
            + "&SpecificName=" + publicationHistoryItem.projectName
            + "&StartCommentDate=" + datePipe.transform(new Date(), 'yyyy-MM-ddT00:00:00')
            + "&EndCommentDate=" + publicationHistoryItem.commentsDue
            + "&DaysToReview=4"
            + "&SubjectStatus=" 
            + "&Town=" + publicationHistoryItem.location
            + "&Email=" + "@mail.com"
            + "&DocumentType=" + publicationHistoryItem.type
            + "&ExternalDbId=" + publicationHistoryItem.submittalId
            + "&Reviewer="  + publicationHistoryItem.mepaAnalyst;

        window.open(redirectURL, "_blank");
    }
}

